module.exports = __webpack_public_path__ + "assets/img/样机-min.d4cc5840.png";